<template>
  <div class="modal_card">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>Редактировать данные</h1>
      <form @submit.prevent="submitUser">
        <b-field
          label="Имя:"
          type="is-info"
          class="left_input has_icon"
          :message="errors.first('name')"
          :class="errors.first('name') ? 'error' : ''"
        >
          <b-input
            placeholder="Имя"
            v-model="newProfile.name"
            name="name"
            icon="mdi mdi-account"
            v-validate="{ min: 2, max: 20 }"
          ></b-input>
        </b-field>
        <b-field
          label="Фамилия:"
          type="is-info"
          class="right_input has_icon"
          :message="errors.first('surname')"
          :class="errors.first('surname') ? 'error' : ''"
        >
          <b-input
            placeholder="Фамилия"
            v-model="newProfile.surname"
            name="surname"
            icon="mdi mdi-account"
            v-validate="{ min: 2, max: 20 }"
          ></b-input>
        </b-field>
        <b-field
          label="Отчество:"
          type="is-info"
          class="left_input has_icon"
          :message="errors.first('patronymic')"
          :class="errors.first('patronymic') ? 'error' : ''"
        >
          <b-input
            placeholder="Отчество"
            v-model="newProfile.patronymic"
            name="patronymic"
            icon="mdi mdi-account"
            v-validate="{ max: 20 }"
          ></b-input>
        </b-field>
        <b-field label="Должность:" type="is-info" class="right_input has_icon">
          <b-input
            placeholder="Должность"
            v-model="newProfile.position"
            name="position"
            icon="mdi mdi-account-tie"
            type="text"
          ></b-input>
        </b-field>
        <b-field
          v-if="modalInfo.profileModal && userRole != 'user'"
          label="Email:"
          type="is-info"
          class="login_input left_input has_icon"
          :message="errors.first('email')"
          :class="errors.first('email') ? 'error' : ''"
        >
          <b-input
            placeholder="Email"
            v-model="newProfile.email"
            name="email"
            icon="mdi mdi-email"
            type="text"
            v-validate="{ email: true, regex: /^[^а-яА-Я]+@([^а-яА-Я]+\.)+[^а-яА-Я]{2,}$/ }"
          ></b-input>
        </b-field>
        <b-field
          v-if="modalInfo.profileModal"
          label="Новый пароль:"
          class="profile_password has_icon"
          type="is-info"
          :message="errors.first('password')"
          :class="
            errors.first('password')
              ? userRole === 'user'
                ? 'left_input error'
                : 'right_input error'
              : userRole === 'user'
              ? 'left_input'
              : 'right_input'
          "
        >
          <b-input
            name="password"
            type="password"
            ref="password"
            placeholder="Пароль"
            icon="mdi mdi-lock"
            v-model="newProfile.password"
            v-validate="{ min: 8, max: 24, regex: /^[^а-яА-Я]{8,24}$/ }"
          ></b-input>
        </b-field>
        <b-field
          v-if="modalInfo.profileModal"
          label="Повторить новый пароль:"
          class="profile_confirm has_icon"
          type="is-info"
          :message="errors.first('password_confirmation')"
          :class="
            errors.first('password_confirmation')
              ? userRole === 'user'
                ? 'right_input error'
                : 'error'
              : userRole === 'user'
              ? 'right_input'
              : ''
          "
        >
          <b-input
            v-validate="{ confirmed: 'password', required: newProfile.password.length ? true : false }"
            name="password_confirmation"
            type="password"
            data-vv-as="password"
            placeholder="Повторить пароль"
            v-model="newProfile.password_confirmation"
            icon="mdi mdi-lock"
          ></b-input>
        </b-field>
        <button class="add_user_button modal_button left_button" type="submit" :disabled="errors.items.length > 0">
          Сохранить
        </button>
        <button @click="$emit('close-modal')" class="close_button modal_button right_button">Отмена</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modalInfo: {
      default: () => {},
      type: Object
    },
    newProfile: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      isLoading: false,
      dict: {
        custom: {
          name: {
            required: 'Поле не заполнено',
            min: 'Слишком короткое значение',
            max: 'Слишком длинное значение'
          },
          surname: {
            required: 'Поле не заполнено',
            min: 'Слишком короткая фамилия',
            max: 'Слишком длинная фамилия'
          },
          patronymic: {
            max: 'Слишком длинное значение'
          },
          position: {
            required: 'Поле не заполнено'
          },
          email: {
            required: 'Поле не заполнено',
            email: 'Неверный формат',
            regex: 'Логин должен состоять из латинских букв'
          },
          password: {
            min: 'Слишком короткий пароль',
            max: 'Слишком длинный пароль',
            regex: 'Пароль должен состоять из латинских букв и цифр'
          },
          password_confirmation: {
            confirmed: 'Пароли не совпадают'
          }
        }
      }
    }
  },
  methods: {
    submitUser() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('click')
        }
      })
    },
  },
  created() {
    this.$validator.localize('ru', this.dict)
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    },
  }
}
</script>
